// import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion'; 
import { SearchIcon, PencilAltIcon, DocumentTextIcon, ClipboardCheckIcon, CogIcon } from '@heroicons/react/outline'; // Ensure this is correct
// import { Settings, Search, Edit, Clock, Heart } from 'lucide-react'; // Ensure this is correct
import React, { useState } from 'react';
import { useAuthStore } from "../store/authStore";
import { FaUser } from "react-icons/fa";
// import PaymentHistoryPage from "./PaymentHistoryPage";

// Data
const evaluationItems = [
    {
      title: 'Content',
      subItems: [
        {
          subTitle: 'Genre Adherence'
        },
        {
          subTitle: 'Coherence and Cohesion'
        }
      ],
      backgroundImage: '/images/demo.jpeg', // replace with your image URL
    },
    {
      title: 'Organization',
      subItems: [
        {
          subTitle: 'Paragraph Order and Logic'
        },
        {
          subTitle: 'Sentence Structure'
        }
      ],
      backgroundImage: '/images/structure.jpeg', // replace with your image URL
    },
    {
      title: 'Language',
      subItems: [
        {
          subTitle: 'Vocabulary Richness'
        },
        {
          subTitle: 'Grammatical Range and Accuracy'
        }
      ],
      backgroundImage: '/images/tone.jpeg', // replace with your image URL
    },
    {
      title: 'Thought Process',
      subItems: [
        {
          subTitle: 'Creativity and Innovation'
        },
        {
          subTitle: 'Critical Thinking and Mindset'
        }
      ],
      backgroundImage: '/images/criticalthinking.jpeg', // replace with your image URL
    },
    {
      title: 'Communication',
      subItems: [
        {
          subTitle: 'Appropriateness to Genre'
        },
        {
          subTitle: 'Formality and Tone as per Genre'
        }
      ],
      backgroundImage: '/images/communication.jpeg', // replace with your image URL
    },
    {
      title: 'Emotion',
      subItems: [
        {
          subTitle: 'Emotional Awareness'
        },
        {
            subTitle: 'Empathy'
        }
      ],
      backgroundImage: '/images/emotion.jpeg', // replace with your image URL
    }
  ];

const testimonials = [
{
    image: 'https://iwritealong.com/wp-content/uploads/2024/07/man.png',
    name: 'Rana S. (student)',
    text: 'I loved the feedback, it was very helpful and I would recommend this service to anyone who wants to improve their writing!'
},
{
    image: 'https://iwritealong.com/wp-content/uploads/2024/07/girl.png',
    name: 'John B. (professional)',
    text: 'This is a fantastic tool for anyone who writes professionally. The feedback is incredibly detailed and useful, and it\'s helped me improve my writing skills significantly.'
},
{
    image: 'https://iwritealong.com/wp-content/uploads/2024/07/man-1.png',
    name: 'Sarah T. (author)',
    text: 'I\'ve been using WriteAlong for a while now, and I can\'t recommend it enough. It\'s helped me refine my writing style, and I\'ve seen a noticeable improvement in the quality of my work.'
},
{
    image: 'https://iwritealong.com/wp-content/uploads/2024/07/girl.png',
    name: 'Emily R. (teacher)',
    text: 'WriteAlong has been an incredible resource for me and my students. The insights it provides are practical and actionable, making it an essential tool for improving writing skills.'
},
{
    image: 'https://iwritealong.com/wp-content/uploads/2024/07/man-1.png',
    name: 'Alex P. (freelancer)',
    text: 'As a freelancer, I constantly need to refine my writing to attract clients. WriteAlong has been a game changer for me, offering great feedback and tips that are easy to implement.'
}
];


    

const LandingPage = () => {

  const { user, isAuthenticated, logout } = useAuthStore();
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  // const [showPaymentHistory, setShowPaymentHistory] = useState(false);

  const toggleProfileMenu = () => {
    setShowProfileMenu(!showProfileMenu);
  };

  // const openPaymentHistory = () => {
  //   setShowPaymentHistory(true);
  //   setShowProfileMenu(false);
  // };

  // const closePaymentHistory = () => {
  //   setShowPaymentHistory(false);
  // };

  const [currentIndex, setCurrentIndex] = useState(0);
  const testimonialsPerPage = 3;

  // Total number of slides
  const totalSlides = Math.ceil(testimonials.length / testimonialsPerPage);

  // Navigate to a specific slide
  const goToSlide = (slideIndex) => {
    const newIndex = slideIndex * testimonialsPerPage;
    setCurrentIndex(newIndex);
  };

  // Get testimonials for the current slide
  const currentTestimonials = testimonials.slice(
    currentIndex,
    currentIndex + testimonialsPerPage
  );


  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navbar */}
      <nav className="flex justify-between items-center px-8 py-5 text-gray-900 bg-white shadow-md">
        <div className="flex items-center space-x-3">
          <img
            src="/images/WriteZenLogo.jpeg"
            alt="WriteZEN Logo"
            className="h-12"
          />
          {/*<h1 className="text-3xl font-bold">WriteZEN</h1>*/}
        </div>
        <div className="space-x-6">
          {/* <Link to="/login">
            <button className="px-6 py-2 bg-gray-200 rounded-lg text-gray-900 hover:bg-gray-300">
              Log in
            </button>
          </Link> */}
          {isAuthenticated ? (
            <div className='flex'>
              <p className="text-lg font-semibold text-gray-900 flex items-center space-x-2 mr-4">
                <span className="text-xl text-blue-600">👋</span> {/* Optional icon */}
                <span>Welcome, <span className="font-bold text-blue-600">{user?.name}</span>!</span> {/* Bold and colored name */}
              </p>
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={toggleProfileMenu}
                className="relative cursor-pointer"
              >
                <FaUser className="text-blue-500 text-2xl" />
                {showProfileMenu && (
                  <div className="absolute right-0 mt-2 w-48 bg-gray-800 border border-gray-700 rounded-lg shadow-lg">
                    <div className="px-4 py-2 text-white font-semibold">Hi, {user.name}!</div>
                    <Link
                      to="/payment-history" // Link to the payment history page
                      state={{ from: 'home' }}
                      className="block px-4 py-2 text-gray-300 hover:bg-gray-700"
                    >
                      Payment History
                    </Link>
                    <button
                      onClick={logout}
                      className="w-full text-left px-4 py-2 text-red-500 hover:bg-gray-700"
                    >
                      Logout
                    </button>
                  </div>
                )}
              </motion.div>
              {/* {showPaymentHistory && <PaymentHistoryPage onClose={closePaymentHistory} />} */}
            </div>
          ) : (
            <Link to="/signup">
              <button className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition duration-300 transform hover:scale-105">
                Sign up
              </button>
            </Link>
          )}
        </div>
      </nav>

      {/* Hero Section */}
    <div className="flex flex-col md:flex-row items-center bg-gray-50">
      {/* Text Section */}
      <div className="w-full md:w-3/4 lg:w-2/3 px-8 py-12 text-center md:text-left">
          <h1 className="text-5xl font-extrabold mb-6">
          Ace your writing with <br />
          Write<span className="text-red-600">ZEN</span>
          </h1>
          <p className="text-lg text-gray-700 mb-8">
            Instant and actionable feedback to take your writing to the next level.
          </p>

          <ul className="list-none pl-2 text-lg text-gray-700 p-1">
            <li className="flex items-center mb-2">
              <span className="w-5 h-5 bg-green-500 text-white rounded-full flex items-center justify-center mr-2">&#10003;</span>
              Writing feedback on over 15 parameters as per the author's age / writing standard.
            </li>
            <li className="flex items-center mb-2">
              <span className="w-5 h-5 bg-green-500 text-white rounded-full flex items-center justify-center mr-2">&#10003;</span>
              Evaluation with awareness of unique structure and content expected across genres.
            </li>
            <li className="flex items-center mb-2">
              <span className="w-5 h-5 bg-green-500 text-white rounded-full flex items-center justify-center mr-2">&#10003;</span>
              Scoring aligned to IELTS / CEFR frameworks.
            </li>
            <li className="flex items-center mb-2">
              <span className="w-5 h-5 bg-green-500 text-white rounded-full flex items-center justify-center mr-2">&#10003;</span>
              Automated detection and flagging of AI generated content.
            </li>
            <li className="flex items-center mb-2">
              <span className="w-5 h-5 bg-green-500 text-white rounded-full flex items-center justify-center mr-2">&#10003;</span>
              Safety check built in to avoid usage of objectionable content.
            </li>
            <li className="flex items-center mb-2">
              <span className="w-5 h-5 bg-green-500 text-white rounded-full flex items-center justify-center mr-2">&#10003;</span>
              Option to download detailed evaluation report instantly.
            </li>
            <li className="flex items-center mb-2">
              <span className="w-5 h-5 bg-green-500 text-white rounded-full flex items-center justify-center mr-2">&#10003;</span>
              Try your first 3 evaluations free, then just Rs. 49 or US $0.60 per evaluation.
            </li>
          </ul>

          {isAuthenticated ? (
            <Link to="/dashboard">
              <button className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
              Evaluate Now
              </button>
            </Link>
          ) : (
            <Link to="/login">
              <button className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
              Get Started
              </button>
            </Link>
          )}
      </div>

      {/* Image Section */}
      <div className="w-full md:w-1/2 h-[60vh]">
          <img
          src="/images/HeroSection2.jpg"
          alt="Writer illustration"
          className="w-full h-full object-cover"
          />
      </div>
    </div>


      {/* What we evaluate section */}
      <section className="py-16 px-8 bg-white">
        <h2 className="text-3xl font-semibold mb-2 text-gray-800 text-center">
            Write<span className="text-red-600">ZEN</span> Evaluation Criteria
        </h2>
        <h3 className="text-xl font-semibold mb-5 text-gray-800 text-center">
            aligned to IELTS and CEFR
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            {evaluationItems.map((item, index) => (
            <motion.div
                key={index}
                className="bg-white p-6 rounded-xl shadow-lg hover:scale-105 transition duration-100"
                style={{
                backgroundImage: `url(${item.backgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '300px', // Reduced height for smaller cards
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
                }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                transition={{ type: 'spring', stiffness: 300 }}
            >
                <h3 className="text-2xl font-semibold text-white mb-2">{item.title}</h3>
                <div className="bg-white bg-opacity-80 p-4 rounded-lg">
                <ul className="text-sm text-gray-1000 font-bold">
                {item.subItems.map((subItem, subIndex) => (
                    <li key={subIndex} className="mb-2 flex items-center">
                    <div className="w-5 h-5 bg-green-500 flex justify-center items-center mr-2 rounded-sm">
                        <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-3 h-3 text-white"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                        >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                        </svg>
                    </div>
                    {subItem.subTitle}
                    </li>
                ))}
                </ul>
                </div>
            </motion.div>
            ))}

            <div>
            <a
              href={`${process.env.PUBLIC_URL}/writezen-evaluation.html`}
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              More Details
            </a>
            </div>
        </div>
      </section>


      {/* How it works section */}
      <section className="py-16 px-8 text-center bg-gray-100">
        <h2 className="text-3xl font-semibold mb-12 text-gray-800 pt-8 text-center">
            Write<span className="text-red-600">ZEN</span> Evaluation Process
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
            <motion.div
            className="p-8 border rounded-xl bg-white shadow-lg hover:bg-gray-50"
            whileHover={{ scale: 1.1, rotateY: 10 }}
            transition={{ type: "spring", stiffness: 300 }}
            >
            <div className="flex items-center mb-4">
                <CogIcon className="w-8 h-8 text-blue-600" />   
                <span className="text-lg font-semibold ml-10">STEP 1</span>
            </div>
            <h3 className="font-semibold text-xl mb-3 text-left">Select Evaluation Standard</h3>
            <p className="text-sm text-gray-600 text-left">
                Choose the evaluation standard that aligns with the author's writing level, from creative to professional.
            </p>
            </motion.div>
            <motion.div
            className="p-8 border rounded-xl bg-white shadow-lg hover:bg-gray-50"
            whileHover={{ scale: 1.1, rotateY: 10 }}
            transition={{ type: "spring", stiffness: 300 }}
            >
            <div className="flex items-center mb-4">
                <SearchIcon className="w-8 h-8 text-blue-600" />
                <span className="text-lg font-semibold ml-10">STEP 2</span>
            </div>
            <h3 className="font-semibold text-xl mb-3 text-left">Pick a Genre</h3>
            <p className="text-sm text-gray-600 text-left">
                Specify the type of writing: essay, story, blog, academic, or creative to tailor your evaluation.
            </p>
            </motion.div>
            <motion.div
            className="p-8 border rounded-xl bg-white shadow-lg hover:bg-gray-50"
            whileHover={{ scale: 1.1, rotateY: 10 }}
            transition={{ type: "spring", stiffness: 300 }}
            >
            <div className="flex items-center mb-4">
                <PencilAltIcon className="w-8 h-8 text-blue-600" />
                <span className="text-lg font-semibold ml-10">STEP 3</span>
            </div>
            <h3 className="font-semibold text-xl mb-3 text-left">Select Evaluation Criterion</h3>
            <p className="text-sm text-gray-600 text-left">
                Focus on aspects like grammar, creativity, coherence, or overall structure for targeted feedback.
            </p>
            </motion.div>
            <motion.div
            className="p-8 border rounded-xl bg-white shadow-lg hover:bg-gray-50"
            whileHover={{ scale: 1.1, rotateY: 10 }}
            transition={{ type: "spring", stiffness: 300 }}
            >
            <div className="flex items-center mb-4">
                <DocumentTextIcon className="w-8 h-8 text-blue-600" />
                <span className="text-lg font-semibold ml-10">STEP 4</span>
            </div>
            <h3 className="font-semibold text-xl mb-3 text-left">Submit for Instant Evaluation</h3>
            <p className="text-sm text-gray-600 text-left">
                Submit your writing to WriteZEN for real-time analysis and instant scoring.
            </p>
            </motion.div>
            <motion.div
            className="p-8 border rounded-xl bg-white shadow-lg hover:bg-gray-50"
            whileHover={{ scale: 1.1, rotateY: 10 }}
            transition={{ type: "spring", stiffness: 300 }}
            >
            <div className="flex items-center mb-4">
                <ClipboardCheckIcon className="w-8 h-8 text-blue-600" />
                <span className="text-lg font-semibold ml-10">STEP 5</span>
            </div>
            <h3 className="font-semibold text-xl mb-3 text-left">Review the Evaluation</h3>
            <p className="text-sm text-gray-600 text-left">
                Receive a detailed explanation and summary of your evaluation, helping you understand strengths and areas for improvement.
            </p>
            </motion.div>
        </div>
      </section>


      <section className="py-16 px-8 bg-gray-50 text-center">
        <h2 className="text-3xl font-semibold mb-12 text-gray-800">
          What our users say
        </h2>

        {/* Testimonial Card Container */}
        <div className="relative">
          <div className="flex space-x-8 justify-center">
            {currentTestimonials.map((testimonial, index) => (
              <div
                key={index}
                className="bg-white shadow-md rounded-lg p-6 max-w-sm flex flex-col items-center text-left"
              >
                {/* Profile Section */}
                <div className="flex items-center gap-4 mb-4">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full border border-gray-200"
                  />
                  <div>
                    <h3 className="font-semibold text-gray-800">
                      {testimonial.name}
                    </h3>
                    <p className="text-sm text-gray-500">
                      {testimonial.name.split("(")[1]?.replace(")", "")}
                    </p>
                  </div>
                </div>
                {/* Testimonial Text */}
                <p className="text-gray-700 italic">"{testimonial.text}"</p>
              </div>
            ))}
          </div>
        </div>

        {/* Dot Indicators */}
        <div className="flex justify-center mt-6 space-x-3">
          {Array.from({ length: totalSlides }).map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full ${
                currentIndex / testimonialsPerPage === index
                  ? "bg-blue-600"
                  : "bg-gray-400"
              } hover:bg-blue-500`}
            />
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 bg-gray-800 text-white text-center">
        <div className="text-sm mb-4">
            Write-Along Stories® © 2024 All Rights Reserved
        </div>
        <div className="flex justify-center gap-6">
            <a
            href="https://iwritealong.com/term-of-service/"
            className="hover:underline text-sm text-gray-300"
            >
            Terms and Service
            </a>
            <a
            href="https://iwritealong.com/privacy-policy/"
            className="hover:underline text-sm text-gray-300"
            >
            Privacy Policy
            </a>
            <a
            href="https://iwritealong.com/contact-us/"
            className="hover:underline text-sm text-gray-300"
            >
            Contact Us
            </a>
        </div>
       </footer>

    </div>
  );
};

export default LandingPage;
